import styled from 'styled-components'

import { CardContentStyled, CardStyled } from '@ui/elements/Card'
import { CollapsibleContentStyled } from '@ui/elements/Collapsible/styles/CollapsibleContentStyled'

interface IAccordionStyledProps {
  expandable?: boolean
  collapsible?: boolean
  hoverable?: boolean
  isExpanded: boolean
}

export const AccordionStyled = styled.div<IAccordionStyledProps>`
  ${CardStyled} {
    box-shadow: ${(props) =>
      props.expandable ? props.theme.shadows[4] : 'none'};
    border: ${(props) =>
      props.expandable
        ? 'none'
        : '1px solid ' + props.theme.colors.content.border};
  }

  ${CardContentStyled} {
    color: ${(props) =>
      props.expandable
        ? props.theme.colors.text.primary
        : props.theme.colors.text.disabled};
    padding: 0;
  }

  .title {
    cursor: ${(props) =>
      (!props.expandable && !props.isExpanded) ||
      (!props.collapsible && props.isExpanded)
        ? 'auto'
        : 'pointer'};
    padding: ${(props) =>
      props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)};
  }

  .content {
    padding: 0
      ${(props) =>
        props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)}
      ${(props) =>
        props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)};
  }

  ${CollapsibleContentStyled} {
    padding-top: 0;
  }

  &:hover ${CardStyled} {
    background-color: ${(props) =>
      !props.isExpanded && props.expandable && props.hoverable
        ? props.theme.colors.offwhite
        : props.theme.colors.white};
  }
`
